import { render, staticRenderFns } from "./xtype_internal_nav.vue?vue&type=template&id=6eb1667e&"
import script from "./xtype_internal_nav.vue?vue&type=script&lang=js&"
export * from "./xtype_internal_nav.vue?vue&type=script&lang=js&"
import style0 from "./xtype_internal_nav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "xtype_internal_nav.vue"
export default component.exports